import React, { useEffect } from "react";
import { Button, notification } from "antd";
export const UPDATE_AVAILABLE_NOTIFICATION_KEY = "pd3751-update-available";
/**
 * Shows the persistent "new version" notification (PD-3751). The fixed key keeps it to one banner at a time, and it
 * can be called again after the user closed it, so a suppressed error toast is never silent.
 */
export const showUpdateAvailableBanner = () => {
    notification.info({
        key: UPDATE_AVAILABLE_NOTIFICATION_KEY,
        message: "A new version of Autosled is available",
        description: "Refresh to get the latest version.",
        duration: 0,
        btn: (React.createElement(Button, { type: "primary", size: "small", onClick: () => window.location.reload() }, "Refresh")),
    });
};
const UpdateAvailableBanner = ({ visible }) => {
    useEffect(() => {
        if (visible)
            showUpdateAvailableBanner();
    }, [visible]);
    return null;
};
export default UpdateAvailableBanner;
